// Auto-generated skeleton for CraftsmanTaskPersonType

export const CraftsmanTaskPersonType: Api.CraftsmanTaskPersonType = {
  id: 0,
  hp_id: null,
  name: '',
  created: null,
  updated: null,
};

